import { savePDF } from "@progress/kendo-react-pdf";

export const RAIN_PRINT_BODY_CLASS = "rain-sheet-printing";
export const RAIN_PRINT_ROOT_CLASS = "rain-sheet-print-root";

function sanitizeFilePart(value) {
  return String(value || "chuva")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9._-]+/g, "_")
    .replace(/^_+|_+$/g, "")
    .slice(0, 80);
}

export function buildRainMonthFileName({ farmLabel, monthLabel }) {
  const farm = sanitizeFilePart(farmLabel || "fazenda");
  const month = sanitizeFilePart(monthLabel || "mes");
  return `chuva_${farm}_${month}.pdf`;
}

export function buildRainYearFileName({ stationLabel, year }) {
  const station = sanitizeFilePart(stationLabel || "pluviometro");
  const yearPart = sanitizeFilePart(year || "ano");
  return `chuva_${station}_${yearPart}.pdf`;
}

export function cloneRainSheetForExport(element) {
  if (!element || typeof document === "undefined") return null;
  const clone = element.cloneNode(true);
  clone.querySelectorAll("button").forEach((button) => {
    const span = document.createElement("span");
    span.textContent = (button.textContent || "").trim();
    button.parentNode.replaceChild(span, button);
  });
  clone.querySelectorAll(".pluviometer-rain-sheet__print-title").forEach((node) => {
    node.style.display = "block";
  });
  clone.querySelectorAll(".pluviometer-rain-sheet__scroll").forEach((node) => {
    node.style.overflow = "visible";
  });
  return clone;
}

export function canUseNativePrint(win = typeof window === "undefined" ? null : window) {
  if (!win || !win.navigator) return false;
  const ua = String(win.navigator.userAgent || "");
  if (/Electron/i.test(ua) || /Cursor\//i.test(ua)) return false;
  try {
    if (win.parent !== win || win.top !== win) return false;
  } catch (error) {
    return false;
  }
  if (typeof win.acquireVsCodeApi === "function") return false;
  const ancestorOrigins = win.location && win.location.ancestorOrigins;
  if (ancestorOrigins && ancestorOrigins.length > 0) return false;
  const isFirefox = /Firefox|FxiOS/i.test(ua);
  const isSafari = /Safari/i.test(ua) && !/Chrome|Chromium|Android/i.test(ua);
  const isChrome = /Chrome|CriOS|Chromium/i.test(ua);
  return isFirefox || isSafari || isChrome;
}

export function printRainMonthSheet(element) {
  if (!element || typeof document === "undefined" || typeof window === "undefined") {
    return false;
  }
  if (!canUseNativePrint()) {
    return false;
  }

  const cleanup = () => {
    document.body.classList.remove(RAIN_PRINT_BODY_CLASS);
    element.classList.remove(RAIN_PRINT_ROOT_CLASS);
    window.removeEventListener("afterprint", cleanup);
  };

  element.classList.add(RAIN_PRINT_ROOT_CLASS);
  document.body.classList.add(RAIN_PRINT_BODY_CLASS);
  window.addEventListener("afterprint", cleanup);
  window.print();
  return true;
}

export async function exportRainMonthPdf(element, fileName) {
  if (!element) return;
  const clone = cloneRainSheetForExport(element);
  if (!clone) return;

  clone.style.position = "fixed";
  clone.style.left = "-12000px";
  clone.style.top = "0";
  clone.style.background = "#fff";
  clone.style.width = `${Math.max(element.offsetWidth || 960, 960)}px`;
  document.body.appendChild(clone);
  try {
    await savePDF(clone, {
      paperSize: "A4",
      landscape: true,
      margin: "10mm",
      fileName: fileName || "chuva-mes.pdf",
      scale: 0.92,
    });
  } finally {
    if (clone.parentNode) {
      clone.parentNode.removeChild(clone);
    }
  }
}
